import "./mission.css";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { Typewriter } from 'react-simple-typewriter'; 
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const Mission = () => {

   const scrollConfig = {
        trigger: ".mission-gsap",
        start: "top 60%",
        end: "top 40%",
        scrub: 1,
      }
    useGSAP(() => {
    const tl6 = gsap.timeline();
    tl6.from(".mission-heading-gsap", {
      y: 100,
      opacity: 0,
      scrollTrigger:scrollConfig
    });
     tl6.from(".mission-author", {
      y: -100,
      opacity: 0,
      scrollTrigger:scrollConfig
    });
      tl6.from(".mission-quote", {
      x: 100,
      opacity: 0,
      scrollTrigger:scrollConfig
    });
      tl6.from(".mission-quote2", {
      x: -100,
      opacity: 0,
      scrollTrigger:scrollConfig
    });

  });
  

  return (
    <>
      <div className="container mission-gsap py-5">
        <div className="row">
          <div className="col-md-12 col-lg-8 mx-auto text-center">
            <div className="thought mission-heading-gsap" id="thought">
               <Typewriter
          words={[
            
            'We ensure timely delivery of quality products and services, without compromise.'
          ]}
          loop={0} 
          cursor
          cursorStyle='|'
          typeSpeed={50}
          deleteSpeed={30}
          delaySpeed={2000}
        />
              <div className="quote3 mission-quote">❝</div>
              <div className="quote4 mission-quote2">❞</div>
            </div>
            <div className="motive mission-author fw-bold"> Our Mission</div>
          </div>
        </div>
      </div>
    
    </>
  );
};
export default Mission;
